const Calendar = {
  name: 'Calendar',
  props: {
    year: {
      type: [String, Number],
      default: () => new Date().getFullYear(),
    },
    month: {
      type: [String, Number],
      default: () => new Date().getMonth() + 1,
    },
  },
  computed: {
    monthDays() {
      const { year, month } = this;
      const date = new Date(year, month - 1, 1);
      const days = [];
      while (date.getMonth() === month - 1) {
        const y = date.getFullYear();
        const m = [0, ...`${date.getMonth() + 1}`.split('')].splice(-2).join('');
        const d = [0, ...`${date.getDate()}`.split('')].splice(-2).join('');
        days.push({
          week: this.getWeekNumber(y, m - 1, d),
          value: `${y}-${m}-${d}`,
          date: new Date(y, m - 1, d),
        });
        date.setDate(date.getDate() + 1);
      }
      return days;
    },
    firstDayOfMonth() {
      return this.monthDays[0];
    },
    lastDayOfMonth() {
      return this.monthDays[this.monthDays.length - 1];
    },
    monthWeeks() {
      const weeks = [];
      this.monthDays.forEach((day) => {
        if (weeks.indexOf(day.week) === -1) {
          weeks.push(day.week);
        }
      });
      return weeks;
    },
    daysByWeek() {
      return this.monthWeeks.map((week) => ({
        week,
        days: this.monthDays.filter((day) => day.week === week),
      }));
    },
  },
  methods: {
    getWeekNumber(year, month, date) {
      const d = new Date(Date.UTC(year, month, date));
      const dayNum = d.getUTCDay() || 7;
      d.setUTCDate(d.getUTCDate() + 4 - dayNum);
      const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
      return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    },
  },
  render(h) {
    return h(
      'div',
      this.$scopedSlots.default({
        daysByWeek: this.daysByWeek,
      })
    );
  },
};

export default Calendar;
